import React from 'react'
import { BreadBox } from './styles'
import { BiChevronRight } from 'react-icons/bi'

const SequenceQuestion = ({ itensSequence }) => {
  return (
    <BreadBox>
      <ul>
        {itensSequence?.map?.((element, index) => {
          if (itensSequence.length - index > 1) {
            return (
              <li key={index}>
                {element}
                <BiChevronRight size={20} />
              </li>
            )
          }
          return <li key={index}>{element}</li>
        })}
      </ul>
    </BreadBox>
  )
}

export default SequenceQuestion
